module.exports = __webpack_public_path__ + "static/media/11NEPAD5.83e8e496.jpg";